import React from 'react';

interface Props {
  LabelComponent: React.ReactNode;
  children: React.ReactNode;
  className: string;
  htmlFor: string;
  labelAdornment?: React.ReactNode;
}

export default function LabelAdornmentWrapper({
  LabelComponent,
  children,
  className,
  htmlFor,
  labelAdornment,
}: Props) {
  if (labelAdornment) {
    return (
      <div className={className}>
        <div className="flex items-center gap-2">
          {LabelComponent}
          {labelAdornment}
        </div>
        {children}
      </div>
    );
  }

  return (
    <label htmlFor={htmlFor} className={className}>
      {LabelComponent}
      {children}
    </label>
  );
}
